import { loginByUserName, getInfo, getMenu, cancel, logout } from '@/api/login';
import { getToken, clearToken } from '@/utils/auth';
import { sha256 } from 'js-sha256'
import CryptoJS from 'crypto-js'

const user = {
  state: {
    token: null,
    userInfo: null,
    menuInfo: null,
    userState: false,
    menuState: false
  },
  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token;
    },
    SET_USER_INFO: (state, userInfo) => {
      state.userInfo = userInfo;
    },
    SET_MENU_INFO: (state, menuInfo) => {
      state.menuInfo = menuInfo;
    },
    SET_USER_STATE: (state, status) => {
      state.userState = status;
    },
    SET_MENU_STATE: (state, status) => {
      state.menuState = status;
    },
    LOGOUT_USER: state => {
      state.user = null;
      state.menuInfo = null;
      state.token = null;
      clearToken();
    }
  },
  actions: {
    LoginByUsername ({commit}, userInfo) {
      const time = userInfo.time;
      const vcode = userInfo.vcode;
      const userName = userInfo.username.trim();
      const password = sha256(userInfo.password.trim());
      const word = `${userInfo.time}|${password}`;
      const name = setCryptoJs(userName);     
      const pass = setCryptoJs(word);
      return new Promise((resolve, reject) => {        
        loginByUserName(name, pass, time, vcode).then(response => {
          resolve(response);
        }).catch(error => {
          reject(error);
        })
      })
    },
    GetToken ({commit}) {
      return new Promise((resolve, reject) => {
        commit('SET_TOKEN', getToken());
        resolve();
      })
    },

    ClearToken ({commit}) {
      return new Promise((resolve, reject) => {
        clearToken().then(() => {
          commit('SET_TOKEN', null);
          commit('LOGOUT_USER');
          resolve();
        })
      })
    },

    GetInfo ({commit, state}) {
      return state.userInfo && !state.userState ?
        Promise.resolve(state.userInfo) :
        new Promise((resolve, reject) => {
          getInfo().then(response => {
            const data = response.data;
            commit('SET_USER_INFO', data);
            resolve(data);
          }).catch(error => {
            reject(error);
          })
        })
    },

    GetMenu ({commit, state}) {
      return state.menuInfo && !state.menuState ?
        Promise.resolve(state.menuInfo) :
        new Promise((resolve, reject) => {
          getMenu().then(response => {
            const data = response.data;
            commit('SET_MENU_INFO', data);
            resolve(data);
          }).catch(error => {
            reject(error);
          })
        })
    },

    Cancel ({dispatch, commit, state}) {
      return new Promise((resolve, reject) => {
        cancel().then(response => {
          dispatch('GetTreeData');
          commit('SET_MENU_STATE', true);
          commit('SET_USER_STATE', true);
          Promise.all([dispatch('GetMenu'), dispatch('GetInfo'), dispatch('GetPowerBtn')]).then(() => {
              resolve();
            });
          });
        }).catch(error => {
          reject(error);
        })
    },

    Logout ({commit, state}) {
      return new Promise((resolve, reject) => {
        logout(this.getters.objApi.NODE_ID ).then(response => {
          resolve();
        }).catch(error => {
          reject(error);
        })
      })
    }
  }
}

const setCryptoJs = (value) => {
  const keyHex = CryptoJS.enc.Utf8.parse('lianyitech');
  let _val = CryptoJS.DES.encrypt(value, keyHex, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  });
  let val = encodeURIComponent(_val.toString());
  return val;
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js